import React, { useEffect, useState } from "react";
import "./profileCard.css";
import clinicService from "../../Services/clinicService";
import Widgets from "..";
import { t } from "../../Utils/translate";
import utils from "../../Utils";

function ViewClinicProfileCard({ hospitalDetails }) {
  const [clinicDetails, setClinicDetails] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLangEn, setIsLangEn] = useState(true);

  useEffect(() => {
    const language = localStorage.getItem("i18nextLng");
    if (language) {
      let langCode;
      switch (language) {
        case "en-US":
          langCode = "en";
          break;
        case "vietnam":
          langCode = "vietnam";
          break;
        case "en":
          langCode = "en";
          break;
        default:
          langCode = "en";
      }
      if (langCode !== "en") {
        setIsLangEn(false);
      }
    }
  }, []);

  useEffect(() => {
    setClinicDetails(hospitalDetails);
  }, [hospitalDetails]);

  return (
    <>
      {isLoading ? (
        <Widgets.CircularLoader />
      ) : (
        <div className="profile-card">
          <div>
            <div className="d-flex align-items-center">
              <div className="profile-card-image-view ">
                {clinicDetails.hospitalLogo != undefined ? (
                  <img src={clinicDetails.hospitalLogo} className="profile-clinic-image" />
                ) : (
                  <i className="ri-user-add-line profile-clinic-image"></i>
                )}
              </div>
              <div className=" mt-2 profile-card-info-view" data-toggle="tooltip" title={clinicDetails.clinicRegistrationNumber}>
                <div className="profile-card-name-id">{clinicDetails.clinicRegistrationNumber}</div>
                <div className="profile-card-name" data-toggle="tooltip" title={clinicDetails.name}>
                  {clinicDetails.name}
                </div>
                <div className="profile-card-small-info text-nowrap">
                  +{clinicDetails.countryCode} {clinicDetails.phoneNumber}
                </div>
                <div className="profile-card-small-info clinic-email">{clinicDetails.email}</div>
              </div>
            </div>
          </div>
          <hr />
          {clinicDetails.country && clinicDetails.country.timezone ? (
            <div className="d-flex mt-1">
              <div className="w-100 number-input ">{t("timezone")}</div>
              <div className="flex-shrink-1 ">{clinicDetails.country.timezone}</div>
            </div>
          ) : null}
          <hr />
          <div className="d-flex">
            <div className=" w-100 mt-2">
              {t("label_contact")}
              <div className="d-flex">
                <div className=" w-100 board mt-1 profile-card-align">
                  <div className="number  d-flex text-nowrap mt-1 ">
                    <i className="ri-smartphone-line me-1"></i>+{clinicDetails.countryCode} {clinicDetails.phoneNumber}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div className="d-flex">
            <div className=" w-100 mt-2">
              {t("labelAddress")}
              <div className="d-flex">
                <div className=" w-100 board mt-1 profile-card-align">
                  <div className="number  d-flex  mt-1">
                    <i className="ri-map-pin-3-line me-1"></i>
                    {isLangEn ? clinicDetails?.address?.en : clinicDetails?.address?.vi}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
        </div>
      )}
    </>
  );
}

export default ViewClinicProfileCard;
